import { render, staticRenderFns } from "./thirdaccesstable.vue?vue&type=template&id=1ca18273&scoped=true&"
import script from "./thirdaccesstable.vue?vue&type=script&lang=js&"
export * from "./thirdaccesstable.vue?vue&type=script&lang=js&"
import style0 from "./thirdaccesstable.vue?vue&type=style&index=0&id=1ca18273&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca18273",
  null
  
)

export default component.exports